<template>
  <div class="partner-show-container">
    <div class="partner-show-content max-width">
      <div class="title">他们都选择久凌</div>
      <div class="sub-title">服务至上，用心创造</div>
      <swiper ref="HomeSwiper" :options="swiperOption">
        <swiper-slide v-for="slide in swiperSlides" :key="slide.id">
          <img class="partner-icon" :src="slide.src">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import ic_logo_1 from "@/assets/case/ic_logo_1@2x.png";
import ic_logo_2 from "@/assets/case/ic_logo_2@2x.png";
import ic_logo_3 from "@/assets/case/ic_logo_3@2x.png";
import ic_logo_4 from "@/assets/case/ic_logo_4@2x.png";
import ic_logo_5 from "@/assets/case/ic_logo_5@2x.png";
export default {
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          autoplay: true,
          delay: 1000,
        },
        slidesPerView: 5,
        loop: true
      },
      swiperSlides: [
        { id: 1, src: ic_logo_1 },
        { id: 2, src: ic_logo_2 },
        { id: 3, src: ic_logo_3 },
        { id: 4, src: ic_logo_4 },
        { id: 5, src: ic_logo_5 }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.partner-show-container {
  width: 100%;
  .partner-show-content {
    width: 1366px;
    margin: auto;
    text-align: center;
    .title {
      font-size: 18px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: #333;
      line-height: 32px;
      margin-bottom: 1vw;
    }
    .sub-title {
      font-size: 16px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      margin-bottom: 8vw;
    }
    .partner-icon{
      user-select: none;
      height: 4vw;
      margin-bottom: 6vw;
    }
  }
}
</style>
